import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import TwitterSocialShareButton from './Twitter';
import FbSocialShareButton from './Facebook';
import PinterestSocialShareButton from './Pinterest';

const SocialShareButtons = (props) => (
  <Box
    sx={{
      marginTop: '18px',
      '@media (max-width: 576px)': {
        textAlign: 'center',
      },
    }}
    data-testid="social-share-buttons"
  >
    <FbSocialShareButton url={props.url} />
    <TwitterSocialShareButton url={props.url} title={props.title} />
    <PinterestSocialShareButton url={props.url} pinterestMedia={props.pinterestMedia} />
  </Box>
);

SocialShareButtons.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  pinterestMedia: PropTypes.string,
};

SocialShareButtons.defaultProps = {
  title: '',
  url: '',
  pinterestMedia: '',
};

export default SocialShareButtons;
